export default class Direction
{
    public static readonly UP:string = "up";
    public static readonly DOWN:string = "down";
}